module.exports = __webpack_public_path__ + "static/media/OH-third.71201ae0.svg";